"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
class ChatRepositoryConstant {
}
ChatRepositoryConstant.LOAD_NO_LIMIT = -1;
exports.ChatRepositoryConstant = ChatRepositoryConstant;
var Dir;
(function (Dir) {
    Dir[Dir["None"] = 0] = "None";
    Dir[Dir["Before"] = 1] = "Before";
    Dir[Dir["After"] = 2] = "After";
})(Dir = exports.Dir || (exports.Dir = {}));
exports.ChatRepositoryErrorName = "ChatRepositoryError";
class ChatRepositoryError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatRepositoryError = ChatRepositoryError;
//# sourceMappingURL=IChatRepository.js.map